<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Gerenciamento de Vue Componentes Menus</h1>

    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovoVueComponenteMenu" />

    <SGPTabelaComponent
      v-if="listaDeVueComponentesMenus.length"
      :colunas="colunas"
      :dados="listaDeVueComponentesMenus"
      @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
      @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
      @sgpTabelaDeletarSelecionadoEmit="deletarSelecionados"
    ></SGPTabelaComponent>

    <SGPAlertaComponent v-else></SGPAlertaComponent>

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="sm"
      titulo="Cadastro de Vue Componente Menu"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioVueComponenteMenuComponent
        :tipoFormulario="tipoFormulario"
        :vueComponenteMenu="vueComponenteMenu"
      />
    </SGPModalComponent>

    <SGPConfirmacaoDelecaoComponent
      v-if="abrirModalDeletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />

    <SGPLoadingComponent v-if="loadingVueComponentesMenus"/>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioVueComponenteMenuComponent from '../components/FormularioVueComponenteMenuComponent.vue'
import deletar from "@/././common/mixins/deletar.js";

export default {
  components: { FormularioVueComponenteMenuComponent },
  name: "ListagemVueComponenteMenuComponent",

 mixins: [deletar],
  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      itensSelecionados: [],
      abrirModal: false,
      abrirModalDeletarDados: false,
      tipoFormulario: 'salvar',
      vueComponenteMenu: {}
    }
  },
  created () {
    this.listarVueComponentesMenus();
  },
  computed: {
    ...mapGetters('vueComponentesMenus', ['listaDeVueComponentesMenus', 'loadingVueComponentesMenus']),

    colunas () {
      return [
        {
          key: 'selecionar',
          label: '',
          sortable: false
        },
        {
          key: 'rota',
          label: 'Rota',
          sortable: false
        },
        {
          key: 'descricao',
          label: 'Descrição',
          sortable: false
        },
         {
          key: 'acl_sub_modulo.submodulo',
          label: 'Submódulo',
          sortable: false
        }
      ]
    }
  },

  methods: {
    ...mapActions('vueComponentesMenus', ['listarVueComponentesMenus','excluirVueComponentesMenus']),

    gerenciadorDeSelecionados (selecionados) {
      this.itensSelecionados = selecionados;
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar';
      this.vueComponenteMenu = this.itensSelecionados[0];
      this.abrirModal = true;
    },

    confirmarDelecao () {
      this.excluirVueComponentesMenus(this.itensSelecionados);
      this.abrirModalDeletarDados = false;
    },

    adicionarNovoVueComponenteMenu () {
      this.vueComponenteMenu = {};
      this.tipoFormulario = 'salvar';
      this.abrirModal = true;
    },

    fecharModal () {
      this.abrirModal = false;
    }

  }
}
</script>